export default __webpack_public_path__ + "static/media/FiraSans-SemiBold.8d7910e2.woff2";